import { useCallback, useEffect, useRef, useState } from 'react';

export default function useTimer(startTime = null) {
  const interval = useRef(0);
  const [time, setTime] = useState({
    minutes: 0,
    seconds: 0
  });

  const start = useCallback(() => {
    const _startTime = startTime || Date.now();

    interval.current = setInterval(() => {
      const currentTime = new Date().getTime();
      const diff = currentTime - _startTime;
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTime({
        minutes,
        seconds
      });
    }, 1000);
  }, [startTime]);

  const reset = useCallback(() => {
    setTime({
      minutes: 0,
      seconds: 0
    });
  }, []);

  const stop = useCallback(() => {
    reset();
    clearInterval(interval.current);
  }, [reset]);

  useEffect(
    () => () => {
      clearInterval(interval.current);
    },
    []
  );

  return { time, start, stop, reset };
}
